<template>
  <div class="question-image__wrapper" id="canvas-question-image-wrapper">
    <Loading v-if="isLoading" />
    <div
      class="question-image __image-wrapper"
      :class="{'pointer-events-none': isPresentingOrBackstage}"
      v-if="questionImage && !isLoading"
    >
      <div class="question-image __icons">
        <div
          class="question-image __edit-wrapper"
          @click="openEditQuestionImageModal"
          v-tooltip="'Edit image'"
        >
          <font-awesome-icon
            icon="pencil-alt"
            class="question-image __icon"
          />
        </div>
        <div
          class="question-image __delete-wrapper"
          @click="openDeleteQuestionImageModal"
          v-tooltip="'Delete'"
        >
          <font-awesome-icon
            icon="trash-alt"
            class="question-image __icon"
          />
        </div>
      </div>
      <img
        :src="questionImage"
        alt
        class="question-image __image"
        ref="slide-imgg"
        @load="$emit('imageLoaded')"
        id="canvas-question-image"
      >
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Loading from '@/components/Loading'
import EventBus from '@/eventBus'

export default {
  components: {
    Loading,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    ...mapGetters(['isPresenting', 'isBackstage']),
    isPresentingOrBackstage() {
      return this.isPresenting || this.isBackstage
    },
    questionImage() {
      return (this.slideActive.image && this.slideActive.image.xLarge)
    },
  },
  methods: {
    openEditQuestionImageModal() {
      EventBus.$emit('open-edit-question-image-modal')
    },
    openDeleteQuestionImageModal() {
      EventBus.$emit('open-delete-question-image-modal')
    },
  },
}
</script>

<style lang="scss" scoped>
.question-image__wrapper {
  width: 100%;
  height: 100%;
  padding: 30px;
  margin: 0px auto;
  & ::v-deep {
    .spinner {
      width: 120px;
      margin: 0 auto;
    }
    .spinner > div {
      width: 20px;
      height: 20px;
      margin: 0 8px;
    }
  }
  &::v-deep .context-menu-wrapper {
    min-width: 3rem;
  }
  .context-menu-item__wrapper {
    padding-left: 0;
    margin-bottom: 0;
  }

  .question-image {
    &.__icons {
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 4px;
      border: 1px solid #ccc;
      filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.12));
      width: max-content;
      opacity: 0;
      position: absolute;
      top: 1px;
      .__edit-wrapper {
        @apply py-4 pl-4 pr-3 cursor-pointer;
        &:hover .__icon {
          @apply text-primary-100;
        }
      }
      .__delete-wrapper {
        @apply py-4 pl-3 pr-4 cursor-pointer;
        &:hover .__icon {
          @apply text-red-100;
        }
      }
    }
    &.__icon {
      font-size: 1.6em;
      @apply text-base-100;
    }
    &.__image {
      max-width: 100%;
      height: 100%;
      object-fit: contain;
      display: table;
      margin: 0 auto;
    }
    &.__image-wrapper {
      @apply h-full w-max my-0 mx-auto text-center;
      max-width: 100%;
      &:hover {
        .__icons {
          opacity: 1;
          transition: opacity 0.2s ease-out;
        }
      }
    }
  }
}
</style>
